var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-pagination',{attrs:{"current-page":_vm.currentPage,"page-sizes":_vm.pageSizes,"layout":_vm.layout,"page-size":_vm.pageSize,"total":_vm.total,"pager-count":_vm.pagerCount},on:{"size-change":_vm.handleSizeChange,"current-change":_vm.handleCurrentChange}})
}
var staticRenderFns = []

export { render, staticRenderFns }